var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":"Output"}},[(_vm.apiResponse && _vm.apiResponse.output)?_vm._l((_vm.apiResponse.output),function(output,oIndex){return _c('div',{key:`o-${oIndex}`,staticClass:"pl-2"},[_vm._v(" "+_vm._s(output)+" ")])}):_c('p',{staticClass:"pl-2 color-black"},[_vm._v("No data available.")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }